<template>
  <form class="search-form" id="category-search" :action="action">
    <slot></slot>
    <template v-if="list_visible == 'all' || list_visible == 'destinazioni'">
      <treeselect
        class="form-select"
        placeholder="Continenti/Stati"
        :options="sel_destination"
        :searchable="false"
        :default-expand-level="1"
        :disabled="dest_disabled"
        :multiple="false"
        v-model="value"
        @input="changeDestination"
      ></treeselect>
    </template>
    <p class="select-or" v-show="list_visible == 'all'">&nbsp;o&nbsp;</p>
    <template v-if="list_visible == 'all' || list_visible == 'esperienze'">
      <v-select
        class="form-select"
        @input="changeExperience"
        placeholder="I tuoi Interessi"
        :options="sel_experience"
        :disabled="exp_disabled"
      ></v-select>
    </template>

    <input type="submit" value="cerca" />
  </form>
</template>
<script>
// import the component
import Treeselect from '@riophae/vue-treeselect';
// import the styles
import '@riophae/vue-treeselect/dist/vue-treeselect.css';

export default {
  components: { Treeselect },
  props: ['sel_destination', 'sel_experience', 'list_visible'],
  data() {
    return {
      value: null,
      exp_disabled: false,
      dest_disabled: false,
      action: '',
    };
  },
  methods: {
    changeExperience(el) {
      if (el) {
        console.log(el.value);
        this.action = el.value;
        this.dest_disabled =true;
      } else {
        this.action = '';
        this.dest_disabled =false;
      }
    },
    changeDestination: function (value) {
      if (value) {
        this.action = value;
        this.exp_disabled =true;
      } else {
        this.action = '';
        this.exp_disabled =false;
      }
    },
  },
};
</script>
